if(!document.body.classList.contains('template-account')){
  window.localStorage.removeItem('selectedOrderStatusTab');
}
$(document).ready(function(){
  
  //Check Customer Logged in or not
  /*let customerHomeVisited = localStorage.getItem('customerHomeVisited') ? localStorage.getItem('customerHomeVisited') : 'false' ;
  console.log(window.isCustomerLoggedIn,customerHomeVisited)
  if(window.isCustomerLoggedIn == true){
    if(customerHomeVisited == 'false'){
      window.location.href = "/";
      localStorage.setItem('customerHomeVisited',true);
    }else{
      console.log(document.body.classList.contains('template-index'));
      document.body.classList.remove('hide');
    }
  }else{
    localStorage.setItem('customerHomeVisited',false);
    document.body.classList.remove('hide');
  }*/
  
  //For Account Page
  if(document.body.classList.contains('template-account')){
    document.querySelectorAll(`[href*="#open_popup"]`).forEach(function(element){
      element.addEventListener('click',function(e){
        e.preventDefault();
        document.body.classList.add('account-popup-open');
      });
    });
    document.querySelectorAll(`[data-popup-close]`).forEach(function(element){
      element.addEventListener('click',function(){
        document.body.classList.remove('account-popup-open');
      });
    });
  }
  
//   This is for checkout page to open first time information page
  localStorage.setItem('openInformationPage', true);
  
  $("#wk-share-cart-btn").click(function(){
    $(".site-main").addClass("model-popup--open");
    $(".site-main").css("position", "inherit");
  });
  
  
  
  /*if(document.body.classList.value.includes('template-cart')){
    document.querySelectorAll('[type="submit"][name="checkout"]').forEach(function(e){
      e.addEventListener('click',function(ele){
        var form = this.form;
        if(form.querySelector('[type="checkbox"][required]').checked === false){
          window.scroll({
            top:form.querySelector('[type="checkbox"][required]').offsetTop,
            behavior:"smooth"
          })
        }
      })
    })
//     document.querySelector('[type="submit"]').form.querySelectorAll('input[required]')
  }*/
  
  
  
  
  /*function onPageLoad(){

    //console.clear();
    let hasCase = $(".variant-custom-fields.custom-fields-case.active .hide_meta").length ? true: false;
    let hasPieces = $(".variant-custom-fields.custom-fields-pieces.active .hide_meta").length ? true: false;
    $(".product-form--atc-button").prop( "disabled", true );
    let currentselectedqty =  parseInt($("#product-quantity-input").val());
    //     console.log(hasCase,hasPieces);
    let SelectedQuantity = 0;

    if(hasCase){

      SelectedQuantity = parseInt(($(".variant-custom-fields.custom-fields-case.active .hide_meta").text()).split("_")[2]);
      var multipleOf = parseInt(SelectedQuantity);
      let current_selected_int = parseInt($("#product-quantity-input").val());
      //console.log(current_selected_int, multipleOf);
      current_selected_int % multipleOf == 0 ? $(".product-form--atc-button").removeAttr("disabled")  : $(".product-form--atc-button").attr("disabled", "true") ;
      //console.log($('.product-form--atc-button').is(':disabled'));
      $("#product-quantity-select option").each(function(){
        let optionValue = $(this).val();
        (optionValue % multipleOf && optionValue != 10) ? $(this).attr("disabled", 'true') :  $(this).removeAttr("disabled");
      });
    }
    else{
      SelectedQuantity = parseInt(($(".variant-custom-fields.custom-fields-pieces.active .hide_meta").text()));
      var variants_int = parseInt(SelectedQuantity);
      let current_selected_int = parseInt($("#product-quantity-input").val());
      current_selected_int == 1 && variants_int ? $(".product-form--atc-button").attr("disabled", "true") : $(".product-form--atc-button").removeAttr("disabled");
    }
    setActiveVariantCustomFields($form,$variants);
    //     CheckBtnStatus();
  }*/
  window.productQuantityActions = function(){

    var $variants = $('.variant-custom-fields');
    var $form = $('form[action="/cart/add"]');
    var variantMetafields = $('#variant-metafields'),
        currentVarinatId = variantMetafields.data('current-variant');

    console.log("productQuantityActions",currentVarinatId);
  
  function setDropdowValue(currentVarinatId){
    console.log('setDropdowValue')
    if($("#product-quantity-select").length > 0){
      if($("#product-quantity-select option:not([disabled])")[0].value != 10){
        $('.form-field--qty-input').removeClass('visible').addClass('hide');
        $('.form-field--qty-input').find('.form-field-input').removeAttr('name');

        $('.form-field--qty-select').removeClass('hide').addClass('visible');
        $("#product-quantity-select").val($("#product-quantity-select option:not([disabled])")[0].value);
        $('.form-field--qty-select').find('.form-field-input').attr('name','quantity')
      }else{
        $('.form-field--qty-input').removeClass('hide').addClass('visible');
        $('.form-field--qty-input').find('.form-field-input').attr('name','quantity');

        $('.form-field--qty-select').removeClass('visible').addClass('hide');
        $('.form-field--qty-select').find('.form-field-input').removeAttr('name');
        $('.form-field--qty-input #product-quantity-input').val($(`#variant-metafields option[value='${currentVarinatId}']`).data('minpack'))
      }
    }
  }
  
  function onPageLoad(currentVarinatId){
    var metaSelector = $(`#variant-metafields option[value='${currentVarinatId}']`),
        haveMetafield = metaSelector.data('have-metafield'),
        pieces = parseInt(metaSelector.data('pieces')),
        minpack = parseInt(metaSelector.data('minpack'));
    
    if(haveMetafield){
      if(metaSelector.data('minpack') != ''){
        $("#product-quantity-select option").each(function(){
          let optionValue = $(this).val();
          if((optionValue % minpack) && optionValue != 10){
            $(this).attr("disabled","true");
          }else{
            $(this).removeAttr("disabled");
          }
        });
      }else{
        if(metaSelector.data('pieces') != ''){
          $("#product-quantity-select option").each(function(){
            let optionValue = $(this).val();
            (optionValue < pieces) ? $(this).attr("disabled", 'true') :  $(this).removeAttr("disabled");
          });
        }
      }
    }
    setActiveVariantCustomFields($form,$variants);
    //     CheckBtnStatus();
  }
  
  function CheckBtnStatus(){
    $('.product-form--atc-button').is(':disabled') ? $(".product-form--atc-button").html( "Adjust to Case Pack Multiple" ):$(".product-form--atc-button").html( "Add to cart" ); 
  }
  
  function setActiveVariantCustomFields($form, $variants){
    // console.log($form,$variants)
    $variants.hide().removeClass("active");
    var active_variant_id = $form.find('[data-variants][name="id"]').val();
    //console.log(active_variant_id,$variants.filter('.variant-custom-fields[data-variant-id="'+ active_variant_id +'"]'));
    $variants.filter('.variant-custom-fields[data-variant-id="'+ active_variant_id +'"]').show().addClass("active");
    CheckBtnStatus();
  }
  
  setInterval(function(){
    $('.shopify-payment-button__button--unbranded').text('Order Now');
  },1000);

  
    
  onPageLoad(currentVarinatId);
  setDropdowValue(currentVarinatId);
  
    $(document).on("change", ".variants-ui__option-value .variants-ui__option-value-input", function(e){
      setActiveVariantCustomFields($form, $variants);
      onPageLoad($(this).data('variant-id'));
      setDropdowValue($(this).data('variant-id'));
    });

    $("#product-quantity-select").change(function(){    
      let currentselectedqty =  parseInt($("#product-quantity-input").val());
      console.log("currentselectedqty",currentselectedqty);
      let hasCase = $(".variant-custom-fields.custom-fields-case.active .hide_meta").length ? true: false;
      let hasPieces = $(".variant-custom-fields.custom-fields-pieces.active .hide_meta").length ? true: false;
      if(hasCase){
        let metaText = $(".variant-custom-fields.custom-fields-case.active .hide_meta .variant__cf").text().trim();
        if (metaText.includes("minimum_pack_")) {
          let parts = metaText.split("_");
          let quantity = parseInt(parts[2]);
        }else {}
        
        let textValue = $(".variant-custom-fields.custom-fields-case.active .hide_meta").text();
        let SelectedQuantity = (textValue.includes("_")) ? parseInt(textValue.split("_")[2]) : parseInt(textValue) || 0;
        
        var multipleOf = parseInt(SelectedQuantity);
        console.log("multipleOf",multipleOf);
        let current_selected_int = parseInt($(this).children("option:selected").val());
        console.log("current_selected_int",current_selected_int);
        current_selected_int % multipleOf ?  $(".product-form--atc-button").attr("disabled", "true") : $(".product-form--atc-button").removeAttr("disabled");
      }
      else{
        let minQty = parseInt(($(".variant-custom-fields.custom-fields-pieces.active .hide_meta").text()));
        let currentQtySelected = parseInt($(this).children("option:selected").val());
        currentQtySelected >= minQty ?  $(".product-form--atc-button").removeAttr("disabled") : $(".product-form--atc-button").attr("disabled", "true");
      }
      CheckBtnStatus();
    });

    $("#product-quantity-input").on("keypress",function(e) {
      if(e.key == 'Enter'){
          return false;
      }
    })
    
    $("#product-quantity-input").on("input", function(e) {
      var inputval = $(this).val();
      console.log(e);
      if(!inputval.length || parseInt(inputval) == 0 ){
        $(".product-form--atc-button").attr("disabled", "true");
        CheckBtnStatus();
        return;
      }

      let hasCase = $(".variant-custom-fields.custom-fields-case.active .hide_meta").length ? true: false;
      console.log("hasCase",hasCase);
      let hasPieces = $(".variant-custom-fields.custom-fields-pieces.active .hide_meta").length ? true: false;
      if(hasCase){
        // Select the hidden 'variant__cf' content inside 'hide_meta'
        let textValue = $(".variant-custom-fields.custom-fields-case.active .hide_meta").text();
        let SelectedQuantity = (textValue.includes("_")) ? parseInt(textValue.split("_")[2]) : parseInt(textValue) || 0;
        
        console.log("input_SelectedQuantity", SelectedQuantity);

        var multipleOf = parseInt(SelectedQuantity);
        let current_selected_int = parseInt($(this).val());
        console.log("current_selected_int",current_selected_int,);
        current_selected_int % multipleOf ?  $(".product-form--atc-button").attr("disabled", "true") : $(".product-form--atc-button").removeAttr("disabled");
      }
      else{
        let minQty = parseInt(($(".variant-custom-fields.custom-fields-pieces.active .hide_meta").text()));
        let currentQtySelected = parseInt($(this).val());
        currentQtySelected >= minQty ?  $(".product-form--atc-button").removeAttr("disabled") : $(".product-form--atc-button").attr("disabled", "true");
      }
      CheckBtnStatus();
    });
    
  }

  window.productQuantityActions();
  
});

    $(".shapeButton").click(function () {
      $('.desc_p').show();
    });
    $(".shapeButton_1").click(function () {
      $('.desc_p').hide();
    }); 
    $(".shapeButton_2").click(function () {
      $('.desc_p1').show();
    });
    $(".shapeButton_3").click(function () {
      $('.desc_p1').hide();
    }); 
    $(".shapeButton_4").click(function () {
      $('.desc_p2').show();
    });
    $(".shapeButton_5").click(function () {
      $('.desc_p2').hide();
    }); 
    $(".shapeButton_6").click(function () {
      $('.desc_p3').show();
    });
    $(".shapeButton_7").click(function () {
      $('.desc_p3').hide();
    }); 
//   });
  $(function() {
    $("input:radio.store_class_1").click(function() {
      var thisElem = $(this);
      var value = thisElem.val();

      $("."+value).show();
      localStorage.setItem("option_1", value);
    });
    var itemValue = localStorage.getItem("option_1");
    // alert(itemValue);
    if (itemValue !== null) {
      $("input:radio.store_class_1[value=\""+itemValue+"\"]").click();
    } 
    if (itemValue == "no") {
      $('.desc_p').hide();
      $("input:radio.store_class_1[value=\""+itemValue+"\"]").click();
    } 
    $("input:radio.store_class_2").click(function() {
      var thisElem = $(this);
      var value_2 = thisElem.val();
      // alert(value);

      $("."+value_2).show();
      localStorage.setItem("option_2", value_2);
    });
    var itemValue_2 = localStorage.getItem("option_2");
    // alert(itemValue);
    if (itemValue_2 !== null) {
      $("input:radio.store_class_2[value=\""+itemValue_2+"\"]").click();
    }
    if (itemValue_2 == "no") {
      $('.desc_p1').hide();
      $("input:radio.store_class_1[value=\""+itemValue+"\"]").click();
    } 
    $("input:radio.store_class_3").click(function() {
      var thisElem = $(this);
      var value_3 = thisElem.val();
      // alert(value);

      $("."+value_3).show();
      localStorage.setItem("option_3", value_3);
    });
    var itemValue_3 = localStorage.getItem("option_3");
    // alert(itemValue);
    if (itemValue_3 !== null) {
      $("input:radio.store_class_3[value=\""+itemValue_3+"\"]").click();
    }
    if (itemValue_3 == "no") {
      $('.desc_p2').hide();
      $("input:radio.store_class_1[value=\""+itemValue+"\"]").click();
    } 
    $("input:radio.store_class_4").click(function() {
      var thisElem = $(this);
      var value_4 = thisElem.val();
      // alert(value);

      $("."+value_4).show();
      localStorage.setItem("option_4", value_4);
    });
    var itemValue_4 = localStorage.getItem("option_4");
    // alert(itemValue);
    if (itemValue_4 !== null) {
      $("input:radio.store_class_4[value=\""+itemValue_4+"\"]").click();
    }
    if (itemValue_4 == "no") {
      $('.desc_p3').hide();
      $("input:radio.store_class_1[value=\""+itemValue+"\"]").click();
    } 
  });
  
const buttons = document.querySelectorAll(".js-custom-login");

buttons?.forEach((btn) => {
  const product = btn.closest(".productitem");
  const modal = document.querySelector(".custom-modal");  // find the modal inside that product
  const close = modal.querySelector(".close");    // find close button inside that modal

  // Open modal when button clicked
  btn.addEventListener("click", () => {
    modal.style.display = "block";
    document.body.classList.add("modal-open");
  });

  // Close when clicking 'x'
  close.addEventListener("click", () => {
    modal.style.display = "none";
    document.body.classList.remove("modal-open");

  });

  // Close when clicking outside modal content
  window.addEventListener("click", (event) => {
    if (event.target === modal) {
    modal.style.display = "none";
    document.body.classList.remove("modal-open");
    }
  });
});

// model custom login button return to  save 
  document.addEventListener("click", function(e) {
    const link = e.target.closest("[data-modal-content] .custom-login-row a");
    if (link) {
      sessionStorage.setItem("returnPage", window.location.pathname);
      console.log("Saved returnPage:", window.location.pathname);
    }
  });

 document.addEventListener("click", function(e) {
  const link = e.target.closest("a.site-header_account-link-text[href='/pages/new-sign-in']");
  if (link) {
    // Just remove the stored returnPage
    sessionStorage.removeItem("returnPage");
  }
});
